import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  createwarehouse,
  DeleteWareHouseMutation,
  updatewarehouse,
} from "../graphQL/graphMutation";
import URL from "../../pages/Utils/url";
import axios from "axios";

export const addWarehouseService = async (values) => {
  let status = false;
  try {
    const res = await request(BASEURL, createwarehouse, {
      input: {
        ...values,
      },
    });
    status = true;
  } catch (err) {
    console.error(err.message);
    status = false;
  }
  return status;
};

export const addWarehouseRestService = async (formData) => {
  let status = false;
  try {
    const response = await axios.post(
      `${URL}warehouse/newWarehouseAdd/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    status = true;
  } catch (err) {}
  return status;
};
export const updateWarehouseService = async (values, id) => {
  let status = false;
  try {
    const res = await request(BASEURL, updatewarehouse, {
      input: {
        id: id,
        ...values,
      },
    });
    status = true;
  } catch (err) {
    console.error(err.message);
    status = false;
  }
  return status;
};
export const updateWarehouseRestService = async (formData, id) => {
  let status = false;
  try {
    const response = await axios.put(
      `${URL}warehouse/newWarehouseAdd/${id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    status = true;
  } catch (err) {}
  return status;
};
export const DeleteWareHouseService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, DeleteWareHouseMutation, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteWarehouseService error");
    delteStatus = false;
  }
  return delteStatus;
};
